<div class="main">
    <div class="dx-field-title" translate>logs.pageTitle</div>
    <div class="dx-field selector">
        <div class="dx-field-label" translate>_commons.datesStartAndEnd</div>
        <div class="dx-field-value">
            <dx-date-range-box applyValueMode="useButtons" labelMode="hidden" width="300" [max]="maxDate" [(value)]="selectedDates" (onValueChanged)="dateChanged()"></dx-date-range-box>
        </div>
    </div>
    <br />
    <dx-tab-panel #tabs style="height:calc(100vh - 235px);"
                  [selectedIndex]="0"
                  [animationEnabled]="true">
        <dxi-item [title]="'logs.lblFileTransfers' | translate" icon="fas fa-exchange-alt">
            <div>
                <div class="dx-field selector" style="margin:8px;">
                    <div class="dx-field-label">{{ this.currentEnvironmentName }}&nbsp;/</div>
                    <div class="dx-field-value">
                        <app-file-transfer-picker #fileTransferPicker [fileTransfers]="fileTransfers" [(selectedItem)]="selectedFileTransfer" (selectedItemChange)="fileTransferChanged($event)"></app-file-transfer-picker>
                    </div>
                </div>
                <br />
                <div style="height: calc(100vh - 350px);">
                    <dx-data-grid #fileTransferLogsGrid
                                  height="100%"
                                  hoverStateEnabled="true"
                                  keyExpr="id"
                                  [columnAutoWidth]="true"
                                  [dataSource]="fileTransferLogs"
                                  [errorRowEnabled]="false"
                                  [focusedRowEnabled]="true"
                                  [wordWrapEnabled]="false"
                                  (onRowDblClick)="onFileTransferRowDblClick($event)">
                        <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate"></dxo-search-panel>
                        <dxo-header-filter [visible]="true"></dxo-header-filter>
                        <dxo-paging [enabled]="false"></dxo-paging>
                        <dxo-scrolling showScrollbar="always"></dxo-scrolling>
                        <dxo-summary>
                            <dxi-total-item column="transferDate" [displayFormat]="'logs.lblLogsCount' | translate" summaryType="count"></dxi-total-item>
                        </dxo-summary>
                        <dxo-toolbar>
                            <dxi-item location="after">
                                <div *dxTemplate>
                                    <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="loadFileTransferLogs()"></dx-button>
                                </div>
                            </dxi-item>
                            <dxi-item name="searchPanel"></dxi-item>
                        </dxo-toolbar>

                        <dxi-column dataField="transferDate" [caption]="'logs.lblDate' | translate" [calculateCellValue]="displayFileTransferLogDateAsString" dataType="datetime"></dxi-column>
                        <dxi-column dataField="fileTransferName" [caption]="'logs.lblTransfer' | translate" [visible]="showFileTransferColumn"></dxi-column>
                        <dxi-column dataField="logTypeEnums" [caption]="'logs.lblType' | translate" [calculateCellValue]="displayFileTransferLogType"></dxi-column>
                        <dxi-column dataField="localAgent.name" [caption]="'logs.lblLocalAgentName' | translate"></dxi-column>
                        <dxi-column dataField="sourceFileName" [caption]="'logs.lblSourceFileName' | translate"></dxi-column>
                        <dxi-column dataField="sourceFileSize" [caption]="'logs.lblSourceFileSizeKb' | translate" [calculateCellValue]="formatSourceFileSize" [alignment]="'right'"></dxi-column>
                        <dxi-column dataField="targetFileName" [caption]="'logs.lblTargetFileName' | translate"></dxi-column>
                        <dxi-column dataField="targetFileSize" [caption]="'logs.lblTargetFileSizeKb' | translate" [calculateCellValue]="formatTargetFileSize" [alignment]="'right'"></dxi-column>
                        <dxi-column dataField="archivedFileName" [caption]="'logs.lblArchivedFileName' | translate"></dxi-column>
                        <dxi-column dataField="archivedFileSize" [caption]="'logs.lblArchivedFileSizeKb' | translate" [calculateCellValue]="formatArchivedFileSize" [alignment]="'right'"></dxi-column>
                    </dx-data-grid>
                </div>
            </div>
        </dxi-item>
        <dxi-item [title]="'logs.lblRemotePlatforms' | translate" icon="fas fa-desktop">
            <div>
                <div class="dx-field selector" style="margin:8px;">
                    <div class="dx-field-label">{{ this.currentEnvironmentName }}&nbsp;/</div>
                    <div class="dx-field-value">
                        <app-remote-platform-picker #remotePlatformPicker [platforms]="remotePlatforms" (selectedItemChange)="remotePlatformChanged($event)"></app-remote-platform-picker>
                    </div>
                </div>
                <br />
                <div style="height: calc(100vh - 350px);">
                    <dx-data-grid #remotePlatformLogsGrid
                                  height="100%"
                                  hoverStateEnabled="true"
                                  keyExpr="id"
                                  [columnAutoWidth]="true"
                                  [dataSource]="remotePlatformLogs"
                                  [errorRowEnabled]="false"
                                  [focusedRowEnabled]="true"
                                  [wordWrapEnabled]="true"
                                  (onRowDblClick)="onRemotePlatformRowDblClick($event)">
                        <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate"></dxo-search-panel>
                        <dxo-header-filter [visible]="true"></dxo-header-filter>
                        <dxo-paging [enabled]="false"></dxo-paging>
                        <dxo-scrolling showScrollbar="always"></dxo-scrolling>
                        <dxo-summary>
                            <dxi-total-item column="logDate" [displayFormat]="'logs.lblLogsCount' | translate" summaryType="count"></dxi-total-item>
                        </dxo-summary>
                        <dxo-toolbar>
                            <dxi-item location="after">
                                <div *dxTemplate>
                                    <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="loadRemotePlatformLogs()"></dx-button>
                                </div>
                            </dxi-item>
                            <dxi-item name="searchPanel"></dxi-item>
                        </dxo-toolbar>

                        <dxi-column dataField="logDate" [caption]="'logs.lblDate' | translate" [calculateCellValue]="displayRemotePlatformLogDateAsString" dataType="datetime"></dxi-column>
                        <dxi-column dataField="remotePlatformName" [caption]="'logs.lblRemotePlatform' | translate" [visible]="showRemotePlatformColumn"></dxi-column>
                        <dxi-column dataField="logTypeEnums" [caption]="'logs.lblType' | translate" [calculateCellValue]="displayRemotePlatformLogType"></dxi-column>
                        <dxi-column dataField="localAgent.name" [caption]="'logs.lblLocalAgentName' | translate"></dxi-column>
                    </dx-data-grid>
                </div>
            </div>
        </dxi-item>
        <dxi-item [title]="'logs.lblEnvironment' | translate" icon="fas fa-cogs">
            <dx-data-grid #environmentLogsGrid
                          style="margin-top:8px;"
                          height="100%"
                          hoverStateEnabled="true"
                          keyExpr="id"
                          [columnAutoWidth]="true"
                          [dataSource]="environmentLogs"
                          [errorRowEnabled]="false"
                          [focusedRowEnabled]="true"
                          [wordWrapEnabled]="true"
                          (onRowDblClick)="onEnvironmentLogsRowDblClick($event)">
                <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate"></dxo-search-panel>
                <dxo-header-filter [visible]="true"></dxo-header-filter>
                <dxo-paging [enabled]="false"></dxo-paging>
                <dxo-scrolling showScrollbar="always"></dxo-scrolling>
                <dxo-summary>
                    <dxi-total-item column="logDate" [displayFormat]="'logs.lblLogsCount' | translate" summaryType="count"></dxi-total-item>
                </dxo-summary>
                <dxo-toolbar>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="loadEnvironmentLogs()"></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item name="searchPanel"></dxi-item>
                </dxo-toolbar>

                <dxi-column dataField="logDate" [caption]="'logs.lblDate' | translate" [calculateCellValue]="displayEnvironmentLogDateAsString" dataType="datetime"></dxi-column>
                <dxi-column dataField="logTypeEnums" [caption]="'logs.lblType' | translate" [calculateCellValue]="displayEnvironmentLogType"></dxi-column>
                <dxi-column dataField="localAgent.name" [caption]="'logs.lblLocalAgentName' | translate"></dxi-column>
            </dx-data-grid>
        </dxi-item>
    </dx-tab-panel>
</div>

<!-- Display file transfer log popup -->
<app-file-transfer-log #fileTransferLogPopup [log]="displayedFileTransferLog"></app-file-transfer-log>

<!-- Display remote platform log popup -->
<app-remote-platform-log #remotePlatformLogPopup [log]="displayedRemotePlatformLog"></app-remote-platform-log>

<!-- Display environment log popup -->
<app-environment-log #environmentLogPopup [log]="displayedEnvironmentLog"></app-environment-log>

<!-- Loading panel -->
<dx-load-panel [visible]="isLoadPanelVisible" [message]="'_commons.loading' | translate" [position]="{ of: '.app-content', boundary: '.app-content' }"></dx-load-panel>
